module.exports = __webpack_public_path__ + "static/img/1808_1.d31751e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_1.jpg
// module id = pAru
// module chunks = 1